import React from 'react'

export default function OptionIcon() {
    return (
        <svg width="5" height="19" viewBox="0 0 5 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2.5" cy="2.5" r="2.5" fill="white" />
            <circle cx="2.5" cy="9.5" r="2.5" fill="white" />
            <circle cx="2.5" cy="16.5" r="2.5" fill="white" />
        </svg>

    )
}
